/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel, ErrorSeverityEnum } from '@irian-ro/shared-components-module';

@Directive({
  selector: '[wellContactListValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomContactListValidator, multi: true}]
})
export class CustomContactListValidator implements Validator {

  @Input('fieldName') fieldName = "";

  validate(control: AbstractControl) {
    const funcProperties = {
      field: this.fieldName
    };
    return _customContactListValidation.bind(funcProperties)(control);
  }
}

export const customContactListValidator = (fieldName = ""): ValidatorFn => {
  const funcProperties = {
    field: fieldName
  };

  return _customContactListValidation.bind(funcProperties)
}

function _customContactListValidation(control: AbstractControl): ValidationErrors | null {
  let errors: ErrorModel | null = null;
  if (control) {
    const uniqueCompanyUuids = new Set<string>();
    if(control.value) {
      control.value.map((contact: any) => {
        uniqueCompanyUuids.add(contact.companyUuid)
      })
    }
    if (uniqueCompanyUuids.size < 2) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: "SingleCompanyContactsSelectedException"
      }
    }
  }
  return errors ? errors : null;

}
